// extracted by mini-css-extract-plugin
export default {"wrapper":"loader_wrapper__wN63k","ldsGrid":"loader_ldsGrid__mzjUV"};